module.exports = __webpack_public_path__ + "74e51b5e1815910553e8a2b91d3361b5.fbx";